import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pdf-edit-page',
  templateUrl: './pdf-edit-page.component.html',
  styleUrls: ['./pdf-edit-page.component.scss']
})
export class PdfEditPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
